import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthService {

  /**
   * Das BehaviourSubject welches den anderen Klassen bereitgestellt werden kann
   */
  private loginState = new BehaviorSubject<boolean>(false);

  private jwtHelper = new JwtHelperService();

  constructor() {
    if (this.isAuthenticated()) {
      this.setLoginState(true);
    } else {
      this.setLoginState(false);
      localStorage.clear();
    }
  }

  /**
   * Setzt den Jwt-Token im Storage
   * 
   * @param jwt
   */
  public setJwtToken = (jwt: string) => {
    localStorage.setItem('jwt', jwt);
  }

  /**
   * Gibt den im Storage gesetzten Jwt-Token zurück
   * 
   * @returns string
   */
  public getJwtToken = (): string => {
    return localStorage.getItem('jwt');
  }

  /**
   * Funktion zum Setzen des nächsten LoginState der als Observable bereitgestellt wird
   */
  public setLoginState = (state: boolean) => {
    this.loginState.next(state);
  }

  public logout = () => {
    this.clearStorage();
    this.loginState.next(false);
  }

  private clearStorage = () => {
    localStorage.clear();
  }

  /**
   * gibt Zurück ob der Benutzer eingeloggt ist
   */
  public getLoginState = () => {
    return this.loginState.asObservable();
  }

  /**
   * Gibt zurück ob der Benutzer mit dem derzeitigen Token noch authentifiziert ist
   * 
   * @param jwt
   * @returns boolean
   */
  public isAuthenticated = (): boolean => {
    const jwt = this.getJwtToken();
    if (typeof jwt === 'string') {
      try {
        return !this.jwtHelper.isTokenExpired(jwt);
      } catch (err) {
        return false;
      }
    }

    return false;
  }

  /**
   * Gibt ein Array mit allen Rollen des Benutzers zurück
   * 
   * @returns Array<string>
   */
  public getUserRoles = (): Array<string> => {
    if (this.loginState.value) {
      const payload = this.jwtHelper.decodeToken(this.getJwtToken());
      const roles = payload.sub.roles.map(role => role);
      return roles;
    }
    return []; 
  }

  /**
   * Gibt die LandingPage für den derzeit eingeloggten Benutzer zurück
   * 
   * @returns string
   */
  public getLandingPage = (): string => {
    const jwtPayload = this.jwtHelper.decodeToken(this.getJwtToken());
    return jwtPayload.sub.landingPage || '/home';
  }

}
